import ReadonlyArea from "./readonlyArea";

export default ReadonlyArea;
